import { useState, useRef, useCallback } from 'react';
import * as config from '@config';

function useTrip() {
    const [fetching, setFetching] = useState(false);
    const [data, setData] = useState({});

    const abortRef = useRef();

    const fetchTrip = useCallback(async (tripID) => {
        setFetching(true);
        abort();
        abortRef.current = new AbortController();
        try {
            const response = await fetch(`${config.apiURL}/trip/${tripID}`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                },
                signal: abortRef.current.signal,
            });
            if (!response.ok) {
                const data = await response.json();
                throw new Error(data.error || 'An error occurred fetching trip');
            }
            const result = await response.json();
            const { trip } = result;
            setData(trip);
            return result;
        } catch (error) {
            if (error.name === 'AbortError') {
                console.log('Request was aborted');
                throw new Error('Request was aborted');
            } else {
                console.error('Error fetching trip:', error);
            }
            throw error;
        } finally {
            setFetching(false);
        }
    }, []);

    const abort = useCallback(() => {
        if (abortRef.current) {
            abortRef.current.abort();
        }
    }, []);

    return { fetching, data, fetchTrip, abort };
}

export default useTrip;
